import { createFileRoute } from "@tanstack/react-router";
import { getRoomBySlug } from "../../data/data-layer";
import RoomPage from "../../pages/RoomPage";
import HeadManager from "../../services/HeadManager";
import dayjs from "dayjs";

export const Route = createFileRoute("/rooms/$roomId")({
  head: (ctx) => {
    return HeadManager.routerHead(ctx);
  },
  beforeLoad: async ({ params, context }) => {
    const data = await context.queryClient.fetchQuery(
      getRoomBySlug(params.roomId),
    );
    const room = data?.data?.[0];
    return {
      title: room?.title,
      metadata: room?.metadata,
    };
  },
  loader: async ({ params, context: { queryClient } }) => {
    const room = await queryClient
      .fetchQuery(getRoomBySlug(params.roomId))
      .then((data) => data?.data?.[0]);

    const today = dayjs();
    const defaultStartDate = today.add(2, "day").format("YYYY-MM-DD");
    const defaultEndDate = today.add(9, "day").format("YYYY-MM-DD");

    return {
      room,
      defaultStartDate,
      defaultEndDate,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { room, defaultStartDate, defaultEndDate } = Route.useLoaderData();

  return (
    <RoomPage
      room={room}
      defaultStartDate={defaultStartDate}
      defaultEndDate={defaultEndDate}
    />
  );
}
